export function getSocketServerUrl(apiUrl = '', currentOrigin = '') {
  const resolvedOrigin = currentOrigin || (typeof window !== 'undefined' ? window.location.origin : '');
  const debugInfo = {
    apiUrl,
    resolvedOrigin,
  };

  if (apiUrl) {
    const trimmed = apiUrl.trim();

    if (!trimmed || trimmed === '/api') {
      const fallback = resolvedOrigin || 'http://localhost:5000';
      console.debug('[socketUrl] using fallback origin', { ...debugInfo, fallback });
      return fallback;
    }

    if (trimmed.includes('/api')) {
      const url = trimmed.replace(/\/api(\/)?$/, '');
      console.debug('[socketUrl] stripped /api from apiUrl', { ...debugInfo, url });
      return url;
    }

    console.debug('[socketUrl] using apiUrl directly', { ...debugInfo });
    return trimmed;
  }

  if (resolvedOrigin && resolvedOrigin.includes('localhost')) {
    console.debug('[socketUrl] localhost detected, using local socket server');
    return 'http://localhost:5000';
  }

  console.debug('[socketUrl] no apiUrl, using resolved origin', { ...debugInfo });
  return resolvedOrigin || 'http://localhost:5000';
}
